export default __webpack_public_path__ + "static/media/Aeonik-SemiBold.d13f29b3.woff2";